// extracted by mini-css-extract-plugin
export default {"container":"AnonymousLayout_container__B9qQg"};